module.exports = __webpack_public_path__ + "static/media/Group.d41be061.png";